module.exports = __webpack_public_path__ + "img/43_10.7548b942.png";